import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_SUBSCRIPTIONS_ACTIVE } from "../../../common/URLs";

export const fetchCandidateActiveSubscriptions = async () => {
    const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_SUBSCRIPTIONS_ACTIVE}`; // Proxy path
    try {
        const token = await fetchToken()

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        // console.log("response", response)
        const data = await response.json();
        return data;
    } catch (error) {
        console.log("error", error);
    }
};